import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "./pages/Home";
import BandMembers from "./pages/BandMembers";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminCallback from "./pages/admin/AdminCallback";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminShows from "./pages/admin/AdminShows";
import AdminMembers from "./pages/admin/AdminMembers";
import AdminGallery from "./pages/admin/AdminGallery";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminSessions from "./pages/admin/AdminSessions";
import AdminSocialMedia from "./pages/admin/AdminSocialMedia";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import SEOHead from "./components/SEOHead";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <SEOHead />
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/band-members" element={<BandMembers />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/callback" element={<AdminCallback />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/shows" element={<AdminShows />} />
              <Route path="/admin/members" element={<AdminMembers />} />
              <Route path="/admin/gallery" element={<AdminGallery />} />
              <Route path="/admin/users" element={<AdminUsers />} />
              <Route path="/admin/sessions" element={<AdminSessions />} />
              <Route path="/admin/social-media" element={<AdminSocialMedia />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </HelmetProvider>
  );
}

export default App;